import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { DcAlertModule } from '@datachain/ui-sdk/components/alert';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcToggleButtonsModule } from '@datachain/ui-sdk/components/app-toggle-buttons';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import {
	DcArrayPipeModule,
	DcDayjsDatePipeModule,
	DcTruncatePipeModule,
} from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
	DxCheckBoxModule,
	DxDataGridModule,
	DxTemplateModule,
} from 'devextreme-angular';
import {
	DxiColumnModule,
	DxoColumnChooserModule,
	DxoColumnFixingModule,
	DxoFilterPanelModule,
	DxoFilterRowModule,
	DxoGroupPanelModule,
	DxoHeaderFilterModule,
	DxoLoadPanelModule,
	DxoPagingModule,
	DxoSelectionModule,
	DxoSortingModule,
	DxoStateStoringModule,
} from 'devextreme-angular/ui/nested';

import { AppDcCoreBadgeComponent } from '../ui/components/app-dc-core-badge/app-dc-core-badge.component';
import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { CatalogFilterBarComponent } from './components/catalog-filter-bar/catalog-filter-bar.component';
import { ProjectDeletePopupComponent } from './components/project-delete-popup/project-delete-popup.component';
import { ProjectHomeComponent } from './components/project-home/project-home.component';
import { ProjectListComponent } from './components/project-list/project-list.component';
import { NgProject } from './ng-project';
import { ProjectAdapter } from './project.adapter';
import {
	HomeEffects,
	HomeSelector,
	PermissionEffects,
	PermissionSelector,
	ProjectEffects,
	ProjectFeatureKey,
	projectReducers,
	ProjectSelector,
} from './store';
import { PicsEffects } from './store/pics.effects';
import { PicSelector } from './store/pics.selector';

@NgModule({
	declarations: [
		ProjectListComponent,
		ProjectDeletePopupComponent,
		ProjectHomeComponent,
		CatalogFilterBarComponent,
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(ProjectFeatureKey, projectReducers),
		EffectsModule.forFeature([
			ProjectEffects,
			HomeEffects,
			PermissionEffects,
			PicsEffects,
		]),
		MatCardModule,
		DcTruncatePipeModule,
		DcArrayPipeModule,
		DcPageModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcDayjsDatePipeModule,
		DcAvatarModule,
		DcBadgeModule,
		DcNavigateDirectiveModule,
		DcPanelModule,
		DxDataGridModule,
		DxTemplateModule,
		DxiColumnModule,
		DxoColumnChooserModule,
		DxoColumnFixingModule,
		DxoFilterPanelModule,
		DxoFilterRowModule,
		DxoGroupPanelModule,
		DxoHeaderFilterModule,
		DxoLoadPanelModule,
		DxoPagingModule,
		DxoSelectionModule,
		DxoSortingModule,
		DxoStateStoringModule,
		DcToggleButtonsModule,
		AppDcCoreBadgeComponent,
		DxCheckBoxModule,
		DcAlertModule,
	],
	providers: [
		NgProject,
		ProjectSelector,
		HomeSelector,
		PermissionSelector,
		ProjectAdapter,
		PicSelector,
	],
})
export class ProjectModule {
	public constructor(private readonly injector: Injector) {
		const projectListCmpElement = createCustomElement(ProjectListComponent, {
			injector,
		});
		customElements.define('app-project-list', projectListCmpElement);

		const projectHomeCmpElement = createCustomElement(ProjectHomeComponent, {
			injector,
		});
		customElements.define('app-project-home', projectHomeCmpElement);

		const projectFilterBarCmpElement = createCustomElement(
			CatalogFilterBarComponent,
			{
				injector,
			}
		);
		customElements.define('app-project-filter-bar', projectFilterBarCmpElement);
	}
}
